import { useSettings } from "@/contexts/SettingsContext";

const PLATFORMS = [
  {
    key: "social_instagram",
    label: "Instagram",
    color: "#E4405F",
    gradient: "from-[#F58529] via-[#DD2A7B] to-[#8134AF]",
    icon: "fa-brands fa-instagram",
    prefix: "https://instagram.com/",
  },
  {
    key: "social_facebook",
    label: "Facebook",
    color: "#1877F2",
    icon: "fa-brands fa-facebook",
    prefix: "https://facebook.com/",
  },
  {
    key: "social_youtube",
    label: "YouTube",
    color: "#FF0000",
    icon: "fa-brands fa-youtube",
    prefix: "https://youtube.com/",
  },
  {
    key: "social_whatsapp",
    label: "WhatsApp",
    color: "#25D366",
    icon: "fa-brands fa-whatsapp",
    prefix: "https://wa.me/",
  },
  {
    key: "social_whatsapp_group",
    label: "WhatsApp Grubu",
    color: "#128C7E",
    icon: "fa-brands fa-whatsapp",
    prefix: "",
  },
];

const buildUrl = (platform, value) => {
  if (!value) return "";
  const v = value.trim();
  if (v.startsWith("http://") || v.startsWith("https://")) return v;
  if (!platform.prefix) return v;
  const cleaned = v.replace(/^@/, "");
  return platform.prefix + cleaned;
};

const SocialLinks = () => {
  const { settings } = useSettings();
  if (!settings.social_enabled) return null;

  const active = PLATFORMS.map((p) => ({
    ...p,
    value: settings[p.key] || "",
  })).filter((p) => p.value);

  if (active.length === 0) return null;

  return (
    <section className="animate-fade-up" data-testid="social-links">
      <div className="bg-white rounded-2xl border border-stone-200 shadow-sm p-5 sm:p-6 flex flex-col sm:flex-row sm:items-center gap-4">
        <div className="flex-1">
          <div className="text-[11px] uppercase tracking-[0.2em] text-[#8A252C]/80 font-bold">
            Bize Ulaşın
          </div>
          <h3 className="font-display text-xl font-bold text-[#1F2937] mt-1">
            Sosyal Medya
          </h3>
        </div>
        <div className="flex flex-wrap gap-2">
          {active.map((p) => (
            <a
              key={p.key}
              href={buildUrl(p, p.value)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`social-${p.key}`}
              className={`group w-12 h-12 rounded-full flex items-center justify-center text-white shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all bg-gradient-to-br ${
                p.gradient || ""
              }`}
              style={p.gradient ? {} : { backgroundColor: p.color }}
              title={p.label}
            >
              <i className={`${p.icon} text-lg`} aria-hidden="true" />
              <span className="sr-only">{p.label}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialLinks;
